export default __webpack_public_path__ + "static/media/plasma_capilar.aefa75c7.jpg";